(function () {

"use strict";


// Shopify Theme Editor 不运行
if (
  window.Shopify &&
  Shopify.designMode
) {
  return;
}



const STORAGE_KEY =
"tb_region_preference";


const STORAGE_DAYS =
180;



/*
=================================
获取当前站点
=================================
*/

function getCurrentStore(){


const hostname =
window.location.hostname;


const stores =
window.TB_REGION_CONFIG.stores;



for(
const key in stores
){

const domain =
new URL(
stores[key].domain
).hostname;



if(
hostname.includes(domain)
){

return key;

}

}


return null;

}



/*
=================================
检测用户地区
=================================
*/


function detectUserRegion(){


const language =
navigator.language ||
"";


if(
language.includes("ja")
){

return "JP";

}


if(
language.includes("en-GB")
||
language.includes("en-UK")
){

return "UK";

}


if(
language.includes("en-US")
){

return "US";

}


/*
备用时区判断
*/


const timezone =
Intl.DateTimeFormat()
.resolvedOptions()
.timeZone;



if(
timezone === "Asia/Tokyo"
){

return "JP";

}



if(
timezone === "Europe/London"
){

return "UK";

}



if(
timezone === "America/New_York"
||
timezone === "America/Los_Angeles"
){

return "US";

}



return null;


}





/*
=================================
180天记录
=================================
*/


function hasPreference(){


const data =
localStorage.getItem(
STORAGE_KEY
);



if(!data){

return false;

}



try{


const obj =
JSON.parse(data);



return (

Date.now()
-
obj.time

<
STORAGE_DAYS *
24 *
60 *
60 *
1000

);



}catch(e){

return false;

}



}




function savePreference(region){


localStorage.setItem(

STORAGE_KEY,

JSON.stringify({

region:region,

time:Date.now()

})

);


}




/*
=================================
URL生成
=================================
*/


function buildStoreURL(store){


return (

store.domain +

window.location.pathname +

window.location.search

);


}




/*
=================================
初始化
=================================
*/


function init(){



if(
hasPreference()
){

return;

}



const popup =
document.querySelector(
"#tb-region-popup"
);



if(!popup){

return;

}




const currentStore =
getCurrentStore();



const userRegion =
detectUserRegion();



/*
无法判断地区
不显示
*/

if(
!userRegion
){

return;

}



/*
已经在对应国家站
不显示
*/

if(
currentStore === userRegion
){

return;

}



const targetStore =
window
.TB_REGION_CONFIG
.stores[userRegion];



if(!targetStore){

return;

}



/*
修改弹窗内容
*/


const flag =
document.querySelector(
"#tb-popup-flag"
);



if(flag){

flag.src =
flag.dataset[
userRegion.toLowerCase()
];

}



const title =
document.querySelector(
"#tb-popup-title"
);



if(title){

title.innerHTML =

`Shopping from ${targetStore.name}?`;

}




const message =
document.querySelector(
"#tb-region-message"
);



if(message){

message.innerHTML =

`Visit our ${targetStore.name} store for local pricing and delivery.`;

}




const switchButton =
document.querySelector(
"#tb-switch-store"
);



if(switchButton){


switchButton.innerHTML =

`Switch to ${targetStore.shortName}`;


switchButton.onclick = async function(e){


e.preventDefault();



savePreference(
userRegion
);



const targetURL =
buildStoreURL(
targetStore
);



try{


const response =
await fetch(
targetURL,
{
method:"HEAD"
}
);



if(
response.ok
){

window.location.href =
targetURL;


}else{


window.location.href =
targetStore.domain;


}



}catch(error){


window.location.href =
targetStore.domain;


}



};


switchButton.onclick = async function(){


const cart =
await fetch('/cart.js')
.then(
res => res.json()
)
.catch(
()=>null
);



function goSwitch(){

savePreference(
userRegion
);


window.location.href =
buildStoreURL(
targetStore
);

}



if(
cart &&
cart.items &&
cart.items.length > 0
){


const confirmSwitch =
confirm(
"Your cart items will not transfer between stores. Continue?"
);



if(
confirmSwitch
){

goSwitch();

}



}else{


goSwitch();


}



};


}





const stay =
document.querySelector(
"#tb-stay-store"
);



if(stay){


stay.onclick=function(){

savePreference(
currentStore
);


popup.classList.remove(
"active"
);


};


}




popup.classList.add(
"active"
);



}




document.addEventListener(

"DOMContentLoaded",

init

);



})();